module.exports = __webpack_public_path__ + "static/media/pla_gra_lor.e74eb2be.png";